import { render } from "./PrescriptionDrugFields.vue?vue&type=template&id=ac7296a2&scoped=true"
import script from "./PrescriptionDrugFields.vue?vue&type=script&lang=js"
export * from "./PrescriptionDrugFields.vue?vue&type=script&lang=js"

import "./PrescriptionDrugFields.vue?vue&type=style&index=0&id=ac7296a2&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7296a2"]])

export default __exports__